import { render, staticRenderFns } from "./control-page.vue?vue&type=template&id=37f95eea&"
import script from "./control-page.vue?vue&type=script&lang=js&"
export * from "./control-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports